import type { Dict } from '@aviata/platform-types';
import type { AirlineFiltersState } from './types';

export const mapAirlines = (
  state: AirlineFiltersState,
  airlines: Dict.Entity['airlines'],
) => {
  const { airlines: airlinesState } = state;
  const isSelected = (iata: string) => airlinesState[iata];

  return Object.values(airlines).map(({ iata, name }) => ({
    iata,
    title: name,
    isSelected: isSelected(iata),
  }));
};
